import { Circle, Path, Svg } from '../../svg';

/**
 * lucide's `circle-x` glyph, drawn once with the shared SVG primitives
 * instead of re-exporting the lucide packages. Chip and Tag render this
 * internally as their dismiss control; keeping it lucide-free lets those
 * components load in web bundles that don't ship `lucide-react` (e.g.
 * flashka-app's `'use dom'` WebViews, where Metro would otherwise fail to
 * resolve the web lucide shims).
 */
export function CircleX({
  color = 'currentColor',
  size = 24,
  strokeWidth = 2,
  className,
}: {
  color?: string;
  size?: number;
  strokeWidth?: number;
  /** Forwarded to the svg — e.g. Badge/Button pass `shrink-0`. */
  className?: string;
}) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <Circle
        cx={12}
        cy={12}
        r={10}
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m15 9-6 6"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="m9 9 6 6"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
